import { toWords } from "number-to-words";

export const parseNumber = (value, fallback = 0) => {
  if (value === undefined || value === null || value === "") return fallback;
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? fallback : parsed;
};

export const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const amountToWords = (amount) => {
  const safeAmount = Math.round(parseNumber(amount));
  if (!safeAmount && safeAmount !== 0) return "";

  const words = toWords(safeAmount)
    .replace(/\s+/g, " ")
    .replace(/(^\w)|(\s\w)/g, (m) => m.toUpperCase());

  return `Indian Rupee ${words} Only`;
};

export const defaultCompanyInfo = {
  name: "Sadashri Ventures Private Limited",
  addressLines: [
    "Flat No: 1323/1324, 16th B Cross Hosing",
    "Board Colony EWS 3rd Phase, Yelahanka New",
    "Town, Bengaluru Urban, Karnataka- 560064",
  ],
  cin: "U46498KA2024PTC185784",
  gstin: "29ABMCS9253K1ZG",
  email: "sadashri.Yel@gmail.com",
  placeOfSupply: "Karnataka (29)",
  branchName: "Sadashri Jewels",
  branchAddressLines: [
    "Shop no. 1 No.2063, Dairy Circle, Asha Arcade,",
    "16th B Cross Rd, Yalahanka New Town, Bangalore- 560064",
  ],
};

export const buildPartyBlock = (data = {}) => {
  const {
    account_name,
    accountName,
    customerName,
    name,
    gst_in,
    gstin,
    gst,
    mobile,
    address1,
    address2,
    city,
    state,
    pincode,
    email,
  } = data;

  const lines = [
    address1,
    address2,
    city && state && pincode ? `${city}, ${state}, ${pincode}` : city && state ? `${city}, ${state}` : city || state || pincode,
  ].filter(Boolean);

  return {
    name: account_name || accountName || customerName || name || "N/A",
    gstin: gst_in || gstin || gst || "",
    addressLines: lines,
    mobile:mobile || "",
    country: "India",
    email: email || "",
  };
};

// export const calculatePaymentReceived = (...values) =>
//   values.reduce((sum, value) => sum + parseNumber(value), 0);
export const calculatePaymentReceived = (...values) => {
  const [cash_amount, card_amt, chq_amt, online_amt, receipts_amt] = values.map(parseNumber);

  return {
    cash_amount,
    card_amt,
    chq_amt,
    online_amt,
    receipts_amt,
    total: cash_amount + card_amt + chq_amt + online_amt + receipts_amt
  };
};


export const isSameState = (state = "", stateCode = "") => {
  if (!state && !stateCode) return true;
  const normalizedState = state.toLowerCase();
  return (
    normalizedState.includes("karnataka") ||
    stateCode.toString().replace(/\D/g, "") === "29"
  );
};

export const formatCurrency = (value) => {
  const amount = parseNumber(value, 0);
  return `${amount.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

